/** Shared events for contact / order UI across the site */
export const OPEN_ORDER_EVENT = "lw-open-order";

export const openOrderModal = () => {
	window.dispatchEvent(new CustomEvent(OPEN_ORDER_EVENT));
};

/** Public Telegram channel/account for live chat with clients */
export const TELEGRAM_CHAT_URL = "https://t.me/LockerWood";
